import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-navy-950 px-4 pb-28 pt-12 sm:px-6 sm:pb-24" data-id="element-164" data-mp="3gezeh7brdx2q">
      <div className="mx-auto w-full max-w-2xl text-center" data-id="element-165" data-mp="3gh3sii3dgcgq">
        <div className="flex items-center justify-center gap-2" data-id="element-166" data-mp="32p5qer82vgu2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-gold-500/50 bg-navy-800" data-id="element-167" data-mp="36oy0j8d4dv1j">
            <ShieldCheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-168" data-mp="3ug3fzmf5elbb" />
          </span>
          <span className="font-display text-base font-bold tracking-tight text-cream-100" data-id="element-169" data-mp="37o38m5zzh95">
            Occlusion <span className="text-gold-400" data-id="element-170" data-mp="3ldkcr17ga6oj">360™</span>
          </span>
        </div>
        <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.16em] text-cream-100/50" data-id="element-171" data-mp="3qcnjqr6zqmz5">
          The Occlusal Decision System
        </p>

        <p className="mx-auto mt-6 max-w-lg text-[12px] leading-relaxed text-cream-100/45" data-id="element-172" data-mp="2a19uvpu8vuyv">
          Occlusion 360™ is an educational decision-support resource. It does not
          replace professional education, clinical training, diagnosis, or
          professional judgment. Clinical decisions must always be based on the
          individual patient’s evaluation.
        </p>

        <p className="mt-6 text-[12px] text-cream-100/55" data-id="element-173" data-mp="3v9193nln3p63">
          © 2026 · Dr. Karito · Occlusion 360™ · All rights reserved.
        </p>

        <p className="mt-3 text-[12px] text-cream-100/55" data-id="element-174" data-mp="82qt3uy8hxus">
          <a href="#" className="underline decoration-cream-100/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-175" data-mp="817e07obdsul">
            Privacy Policy
          </a>
          <span className="px-2 text-cream-100/30" aria-hidden="true" data-id="element-176" data-mp="ctqnotjvs3u4">
            ·
          </span>
          <a href="#" className="underline decoration-cream-100/25 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold-400" data-id="element-177" data-mp="qthyklf3p43w">
            Terms of Use
          </a>
        </p>
      </div>
    </footer>;
}